import React from 'react';
import dribbleGif from '../../assets/images/dribble-white.gif';

import styles from './NoMatch.module.css';

const NoMatch = () => {
  return (
    <>
      <div className={styles.content}>
        <img alt="Bouncing Basketball" className={styles.image} src={dribbleGif} />
        <div className={styles.mainText}>PAGE NOT FOUND</div>
      </div>
    </>
  );
};

export default NoMatch;
